module.exports = __webpack_public_path__ + "media/images/g-logo-fff5178ed726208aaf8210b29400ab71.png";